import { UserInterfaceElement } from './UserInterfaceElement.js';


export class TextareaUserInterfaceElement extends UserInterfaceElement {

    element;
    constructor(elements, json) {
        super(elements, json);
    }

    addToDOM() {

        let id = crypto.randomUUID();


        this.element = Object.assign(document.createElement("textarea"), {
            id: id
        });
        if (this.json.margin) {
            this.element.style.margin = this.json.margin;
        }
        this.element.rows = 16;
        this.element.cols = 27;
        this.elements.div.appendChild(this.element);
    }
    value_string(){
        return this.element.value;
    }
}
